module.exports = {
	"id": "UG",
	"name": "Uganda",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.002624,
			"6": null,
			"7": 0.002624,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.034112,
			"12": 0.005248,
			"13": 0.002624,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.007872,
			"19": 0.002624,
			"20": 0.002624,
			"21": 0.005248,
			"22": 0.005248,
			"23": 0.005248,
			"24": 0.01312,
			"25": 0.010496,
			"26": 0.010496,
			"27": 0.002624,
			"28": 0.01312,
			"29": 0.007872,
			"30": 0.007872,
			"31": 0.03936,
			"32": 0.005248,
			"33": 0.031488,
			"34": 0.005248,
			"35": 0.007872,
			"36": 0.007872,
			"37": null,
			"38": 0.007872,
			"39": 0.01312,
			"40": 0.02624,
			"41": 0.002624,
			"42": 0.01312,
			"43": 0.097088,
			"44": 0.015744,
			"45": 0.020992,
			"46": 0.020992,
			"47": 0.031488,
			"48": 0.01312,
			"49": 0.448704,
			"50": 0.044608,
			"51": 0.154816,
			"52": 0.167936,
			"53": 7.027072,
			"54": 1.700352,
			"55": 0.049856,
			"56": 0.010496,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.028864,
			"4": 0.020992,
			"5": 0.01312,
			"6": 0.010496,
			"7": 0.01312,
			"8": 0.020992,
			"9": 0.020992,
			"10": 0.031488,
			"11": 0.041984,
			"12": 0.057728,
			"13": 0.049856,
			"14": 0.044608,
			"15": 0.03936,
			"16": 0.044608,
			"17": 0.044608,
			"18": 0.031488,
			"19": 0.041984,
			"20": 0.060352,
			"21": 0.041984,
			"22": 0.023616,
			"23": 0.018368,
			"24": 0.05248,
			"25": 0.020992,
			"26": 0.034112,
			"27": 0.020992,
			"28": 0.034112,
			"29": 0.068224,
			"30": 0.094464,
			"31": 0.057728,
			"32": 0.036736,
			"33": 0.044608,
			"34": 0.049856,
			"35": 0.068224,
			"36": 0.055104,
			"37": 0.10496,
			"38": 0.1312,
			"39": 0.110208,
			"40": 0.540544,
			"41": 0.112832,
			"42": 0.062976,
			"43": 0.614016,
			"44": 0.304384,
			"45": 0.251904,
			"46": 0.18368,
			"47": 0.984,
			"48": 0.831808,
			"49": 5.329344,
			"50": 0.926272,
			"51": 0.01312,
			"52": 0.007872,
			"3.5": 0.007872,
			"3.6": 0.028864
		},
		"opera": {
			"9": null,
			"11": 0.002624,
			"12": null,
			"15": null,
			"16": 0.005248,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.002624,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.015744,
			"30": 0.002624,
			"31": null,
			"32": null,
			"33": 0.010496,
			"34": 0.010496,
			"35": 0.01312,
			"36": 0.02624,
			"37": 0.152192,
			"38": 0.007872,
			"39": 0.02624,
			"40": 0.309632,
			"41": 0.047232,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.007872,
			"12.1": 0.01312
		},
		"safari": {
			"0": null,
			"4": 0.002624,
			"5": 0.005248,
			"6": 0.005248,
			"7": 0.015744,
			"8": 0.031488,
			"9": 0.057728,
			"10": 0.083968,
			"3.1": null,
			"3.2": null,
			"5.1": 0.010496,
			"6.1": 0.007872,
			"7.1": 0.005248,
			"9.1": 0.115456
		},
		"ios_saf": {
			"8": 0,
			"10": 0.579854321399,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0156264029975,
			"8.1-8.4": 0.0288691174022,
			"9.0-9.2": 0.0137724229808,
			"9.3": 0.210117735221
		},
		"android": {
			"3": 0,
			"4": 0.0729785633075,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00912232041344,
			"4.1": 0.263244103359,
			"4.2-4.3": 0.658110258398,
			"4.4": 1.50909243411,
			"4.4.3-4.4.4": 1.52212432041
		},
		"ie": {
			"6": 0.00526973084886,
			"7": null,
			"8": 0.20815436853,
			"9": 0.0816808281573,
			"10": 0.118568944099,
			"11": 0.85633126294,
			"5.5": null
		},
		"op_mob": {
			"0": 3.77228538275,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.104785705076
		},
		"edge": {
			"12": 0.133824,
			"13": 0.154816,
			"14": 0.097088
		},
		"ie_mob": {
			"10": 0.187620507042,
			"11": 0.763883492958
		},
		"bb": {
			"7": 0.044256,
			"10": null
		},
		"samsung": {
			"0": 0.899872
		},
		"and_uc": {
			"0": 4.27808
		},
		"op_mini": {
			"0": 50.8233449122
		},
		"and_chr": {
			"0": 7.901616
		},
		"and_ff": {
			"0": 0.022128
		}
	},
	"total": 98.3201331346
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/UG.json
 ** module id = 671
 ** module chunks = 0
 **/